<p-toast />

<!-- ContextMenu -->
    <p-contextMenu #cm [model]="inquiryContextItems" appendTo="body"  triggerEvent="click" (onHide)="onHide()"></p-contextMenu>
<!-- End of ContextMenu -->

<!-- Confirmation Dialog -->
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" styleClass="inquiryDialog" appendTo="body"></p-confirmDialog>
<hr style="margin-top: 0px; margin-bottom: 0px;"/>
<!-- Import CSV -->
    <div class="col-lg-12 text-right">
        <p-popover #uploadFilePanel [style]="{ width: '500px' }">
            <ng-template pTemplate="content">
                <div class="card flex justify-content-center">
                    <p-fileUpload #updfile [url]="FileUploadUrl" [disabled]="isDisableFileUpload"
                        name="queries" [headers]="httpHeaders" (onBeforeUpload)="onBeforeSend($event)" (onSelect)="getUploadedFileList($event)" (onClear)="onCancelUpload($event)"
                        (onUpload)="onUploadFile($event)" accept=".csv" maxFileSize="1000000">
                            <ng-template pTemplate="content">
                                @if (uploadedFiles.length) {
                                    <ul class="list-none">
                                        @for (file of uploadedFiles; track file; let i = $index) {
                                            <li>
                                                {{ file.name }} - {{ file.size }} bytes
                                            </li>
                                        }
                                    </ul>
                                }
                            </ng-template>
                    </p-fileUpload>
                </div>
            </ng-template>
        </p-popover>
    </div>
<!-- End of Import CSV -->

<!-- Inquiry List -->
    @if(inquiryList && inquiryList.length > 0){
        <div class="col-lg-12 nopadding">
            <div class="ui-widget-header-1 nopadding">
                <ul class="nopadding">
                    <label for="inquirylabel" class="inquirylabel"> Inquiry List : </label>
                </ul>
                @for (inquiry of inquiryList; track inquiry + '-'+ $index; let i = $index){
                    <ul class="nopadding">
                        @if(inquiry!='') {
                            <label for="inquiry" (contextmenu)="onContextMenu($event, inquiry)">
                                <button [id]="inquiry?.inquiryId" type="button" type="button" [ngClass]="{'button': true, 'btn-xs': true, 'filterButtons': (!['Completed', 'Deleted'].includes(inquiry?.status)), 'completedBtn': (inquiry?.status === 'Completed'), 'deletedBtn': (inquiry?.status === 'Deleted'), 'active-symbol-save-filter': (this.FinraInquiryServiceService.activeInquiry?.inquiryId===inquiry?.inquiryId), 'non-active-symbol': (!['Completed', 'Deleted'].includes(inquiry?.status) && (this.FinraInquiryServiceService.activeInquiry?.inquiryId!==inquiry?.inquiryId))}">
                                    <a (click)="setInquiryFilter(inquiry)">
                                        <em>{{inquiry.tag}}</em>
                                    </a>
                                    <a class = "close-icon" (click)="removeInquiryFilterQuery(inquiry)">
                                        <em class="fa fa-close"></em>
                                    </a>
                                </button>
                            </label>
                        }
                    </ul>
                }
            </div>
        </div>
    }
<!-- End of Inquiry List -->

<!-- Screen Action Button Panel -->
<div class="col-lg-12 nopadding">
    <div class="col-lg-12 text-right nopadding">
        <p-button matTooltip="Download Template" label="Download Template" class="featureBtn" 
            matTooltipPosition="below" appendTo="body" icon="fa fa-download" (click)="exportSample();" size="small"></p-button>
        <p-button matTooltip="Import CSV" label="Import CSV" class="featureBtn"  
            matTooltipPosition="below" appendTo="body" icon="fa fa-cloud-upload" (click)="(allowtoUploadFile() ? uploadFilePanel.toggle($event) : null)" size="small"></p-button>
        <p-button matTooltip="Fetch Result" label="Fetch Result" class="featureBtn" 
            matTooltipPosition="below" appendTo="body" icon="fa fa-tasks" (click)="onFetchResult();" size="small"></p-button>
        <p-button matTooltip="Reload Screen" label="Reload Screen" class="featureBtn" 
            matTooltipPosition="below" appendTo="body" icon="fa fa-refresh" (click)="getData(false);" size="small"></p-button>
    </div>
</div>


<!-- Table Grid Panel -->
<div class="col-lg-12 nopadding">
    @if(isLoadingResults){
        <div class="example-loading-shade">
            <mat-spinner></mat-spinner>
        </div>
    }
    <!-- Reg Inquiry Tree Table -->
        <p-treetable #tt
            selectionMode="checkbox" 
            [(selection)]="selectedRegInquiryNodes"
            [value]="regInquiryList" 
            [columns]="tblCols" 
            [lazy]="true" 
            (onLazyLoad)="changePage($event)" 
            (onNodeExpand)="onNodeExpand($event)"
            sortMode="multiple" 
            [paginator]="true" 
            appendTo="body" 
            alwaysShowPaginator="true" paginatorPosition="both" 
            [rows]="constantService.DEFAULT_ROWSIZE" 
            [rowsPerPageOptions]="rowsPerPageOptions" 
            [pageLinks]="constantService.DEFAULT_PAGELINKS" showGridlines 
            [totalRecords]="totalRecords" 
            [resizableColumns]="true" columnResizeMode="expand" [autoLayout]="true" responsiveLayout="scroll"
        >
        <ng-template pTemplate="emptymessage" let-columns>
            <tr>
                <td class="text-center" [attr.colspan]="(columns.length+1)">
                    {{tbldatamsg}}
                </td>
            </tr>
        </ng-template>
            <ng-template #header let-columns>
                <tr>
                    @for(col of columns; track col.field + '-'+ $index; let i = $index) {
                    <th id="colHeader" [ttSortableColumn]="col.field" [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay': '' " [ttSortableColumnDisabled]="col.field === 'action' || (!this.FinraInquiryServiceService.activeInquiry?.inquiryId)">
                        @if(i === 0){
                        <p-treeTableHeaderCheckbox/>
                        }
                        {{ col.header }}
                        @if(i !== 0){
                        <p-treeTableSortIcon [field]="col.field" />
                        }
                    </th>
                    }
                </tr>
            </ng-template>
            <ng-template #body let-rowNode let-rowData="rowData" let-columns="columns" let-rowIndex="rowIndex">
                <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode" [ngClass]="(rowData && (rowData['status'] | lowercase)==='modified') ? 'ui-widget-updated-row' : (rowData && (rowData['status'] | lowercase) === 'deleted') ? 'ui-widget-deleted-row' : 'ui-widget-NoUpdated-row'">
                    @for(col of columns; track col.field + '-'+ $index; let i = $index) {
                    <td [ngClass]="(col?.display | lowercase) == 'false' ? 'notdisplay':'' "
                    ttEditableColumn>
                        @if(i === 0){
                            <p-treetable-toggler [rowNode]="rowNode"/>
                            @if((rowData && rowData['parentLevel'] && rowData['parentLevel']!==3)){
                            <p-treetable-checkbox [value]="rowNode" />
                            }
                            @if(rowData && rowData['parentLevel'] && rowData['parentLevel']!==3){
                                <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Delete" [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body"
                                    icon="fa fa-fw fa-trash" [id]="'delete'+ rowIndex" (click)="onRowSelect('Delete',rowNode);"></p-button>
                                <p-button class="pi pi-xxx" or class="fa fa-xxx" matTooltip="Add Comment" [matTooltipShowDelay]="1000" matTooltipPosition="above" appendTo="body"
                                    icon="fa fa-fw fa-comment" [id]="'comment'+ rowIndex" (click)="onRowSelect('Comment',rowNode);"></p-button>
                            }
                        }
                        <!-- Cell Editor -->
                        @if(i !== 0) {
                            @if(rowData && [1, 2].includes(rowData["parentLevel"])) {
                                @if(rowData["parentLevel"]===1 && inquiryEditableCols.includes(col.header)) {
                                    <p-treeTableCellEditor>
                                        <!-- Input Editable Parameters -->
                                        @if ((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'no') {
                                            <ng-template pTemplate="input">
                                                <input pInputText type="text" [id]="col.field+'string'" [(ngModel)]="rowData[col.field]" [placeholder]="(col.placeholder ? col.placeholder : '')"
                                                    (ngModelChange)="onCellEditComplete(col.field, $event, rowData)" [disabled]="col.isDisable" [title]="(col.placeholder ? col.placeholder : '')">
                                            </ng-template>
                                        }
                                        @if ((col?.datatype | lowercase) === 'date') {
                                            <ng-template pTemplate="input">
                                                <p-datepicker inputId="dplt" [touchUI]="true" [(ngModel)]="rowData[col.field]" dateFormat="yy-mm-dd" [placeholder]="(col.placeholder ? col.placeholder : '')" 
                                                (ngModelChange)="onCellEditComplete(col.field, getFormat($event), rowData)" appendTo="body" [disabled]="col.isDisable" [readonlyInput]="false"
                                                [motionOptions]="{ duration: 0 }">
                                                </p-datepicker>
                                            </ng-template>
                                        }
                                        @if ((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'yes' && (col?.dropdowntype | lowercase) === 'singleselect') {
                                            <ng-template pTemplate="input">
                                                <p-select appendTo="body" [name]="col.field+'singleselect'" [id]="col.field+'singleselect'" 
                                                [options]="col.dropdownvalue" [(ngModel)]="rowData[col.field]" [disabled]="col.isDisable" [showClear]="true" 
                                                (ngModelChange)="onCellEditComplete(col.field, $event, rowData)" [placeholder]="'Enter Value'" class="maxChoiceWidth">
                                                </p-select>
                                            </ng-template>
                                        }
                                        <!-- Output Editable Parameters -->
                                        @if ((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'no') {
                                            <ng-template pTemplate="output">
                                                {{rowData[col.field]}}
                                            </ng-template>
                                        }
                                        @if ((col?.datatype | lowercase) === 'date') {
                                            <ng-template pTemplate="output">
                                                {{getFormat(rowData[col.field])}}
                                            </ng-template>
                                        }
                                        @if ((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'yes' && (col?.dropdowntype | lowercase) === 'singleselect') {
                                            <ng-template pTemplate="output">
                                                {{rowData[col.field]}}
                                            </ng-template>
                                        }
                                    </p-treeTableCellEditor>
                                } @else if(rowData && rowData["parentLevel"]===2 && inquiryQueryEditableCols.includes(col.header)) {
                                    <p-treeTableCellEditor>
                                        <!-- Input Editable Parameters -->
                                        @if ((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'no') {
                                            <ng-template pTemplate="input">
                                                <input pInputText type="text" [id]="col.field+'string'" [(ngModel)]="rowData[col.field]" [placeholder]="(col.placeholder ? col.placeholder : '')"
                                                    (ngModelChange)="onCellEditComplete(col.field, $event, rowData)" [disabled]="col.isDisable" [title]="(col.placeholder ? col.placeholder : '')">
                                            </ng-template>
                                        }
                                        @if ((col?.datatype | lowercase) === 'date') {
                                            <ng-template pTemplate="input">
                                                <p-datepicker inputId="dplt" [touchUI]="true" [(ngModel)]="rowData[col.field]" dateFormat="yy-mm-dd" [placeholder]="(col.placeholder ? col.placeholder : '')" 
                                                (ngModelChange)="onCellEditComplete(col.field, getFormat($event), rowData)" appendTo="body" [disabled]="col.isDisable" [readonlyInput]="false"
                                                [motionOptions]="{ duration: 0 }">
                                                </p-datepicker>
                                            </ng-template>
                                        }
                                        @if ((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'yes' && (col?.dropdowntype | lowercase) === 'singleselect') {
                                            <ng-template pTemplate="input">
                                                <p-select appendTo="body" [name]="col.field+'singleselect'" [id]="col.field+'singleselect'" 
                                                [options]="col.dropdownvalue" [(ngModel)]="rowData[col.field]" [disabled]="col.isDisable" [showClear]="true" 
                                                (ngModelChange)="onCellEditComplete(col.field, $event, rowData)" [placeholder]="'Enter Value'" class="maxChoiceWidth">
                                                </p-select>
                                            </ng-template>
                                        }
                                        <!-- Output Editable Parameters -->
                                        @if ((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'no') {
                                            <ng-template pTemplate="output">
                                                {{rowData[col.field]}}
                                            </ng-template>
                                        }
                                        @if ((col?.datatype | lowercase) === 'date') {
                                            <ng-template pTemplate="output">
                                                {{rowData[col.field]}}
                                            </ng-template>
                                        }
                                        @if ((col?.datatype | lowercase) === 'string' && (col?.dropdown | lowercase) === 'yes' && (col?.dropdowntype | lowercase) === 'singleselect') {
                                            <ng-template pTemplate="output">
                                                {{rowData[col.field]}}
                                            </ng-template>
                                        }
                                    </p-treeTableCellEditor>
                                } @else {
                                    @if(col.field === 'status') {
                                        @if(rowData['status'] && [(this.constantService['inquirySelectionValues'][0]['inquiryQueryFields']['status'][4] | lowercase)].includes((rowData['status'] | lowercase))){
                                        <strong [ngStyle]="{'font-size': '14px', 'color': '#22C55E'}">{{ rowData['status'] }}</strong>
                                        }
                                        @if(rowData['status'] && [(this.constantService['inquirySelectionValues'][0]['inquiryQueryFields']['status'][0] | lowercase), (this.constantService['inquirySelectionValues'][0]['inquiryQueryFields']['status'][3] | lowercase)].includes((rowData['status'] | lowercase))){
                                        <strong [ngStyle]="{'font-size': '14px', 'color': '#0EA5E9'}">{{ rowData['status'] }}</strong>
                                        }
                                        @if(rowData['status'] && [(this.constantService['inquirySelectionValues'][0]['inquiryQueryFields']['status'][2] | lowercase)].includes((rowData['status'] | lowercase))){
                                        <strong [ngStyle]="{'font-size': '14px', 'color': '#F97316'}">{{ rowData['status'] }}</strong>
                                        }
                                        @if(rowData['status'] && [(this.constantService['inquirySelectionValues'][0]['inquiryQueryFields']['status'][1] | lowercase), (this.constantService['inquirySelectionValues'][0]['inquiryQueryFields']['status'][6] | lowercase)].includes((rowData['status'] | lowercase))){
                                        <strong [ngStyle]="{'font-size': '14px', 'color': '#EF4444'}">{{ rowData['status'] }}</strong>
                                        }
                                    } @else {
                                        {{ rowData && rowData[col.field] }}
                                    }
                                }
                            } @else {
                                {{ rowData && rowData[col.field] }}
                            }
                        }
                        <!-- End of Cell Editor -->
                    </td>
                    }
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorright">
                <p-button type="button" id="tree-expand-collapse" [label]="expandCollapseAll"
                    (onClick)="exapandORcollapse(regInquiryList)">
                </p-button>
                <app-export-to-csv [gridColumns]="exportGridColumns" (exportToCSVListner)="exportToCSV($event)"></app-export-to-csv>
                Total Records: {{regInquiryList.length === 0 ? 0 : totalRecords}}
            </ng-template>
            <ng-template pTemplate="paginatorleft">
                Showing {{regInquiryList.length === 0 ? 0 : startLimit + 1}} to {{regInquiryList.length
                < rowcount ? regInquiryList.length < startLimit ? endLimit : regInquiryList.length :
                    endLimit }} entries 
            </ng-template>
        </p-treetable>
    <!-- End of Reg Inquiry Tree Table -->
    <br>
    <br>
</div>

<!-- Comment Viewer -->
@if(isDisplayCommentViewer) {
    <app-comment-viewer [pageName]="'Finra-Reg-Inquiry'" [isOpenCommentViewer]="isDisplayCommentViewer" [isDisplayAddCommentForm]="true" [gridColumnsJSON]="this.commentGridColumns" 
      [selectedRow]="this.selectedCommentRow" [commentStaticFilters]="commentStaticFilters" [commentAPIDetail]="commentAPIDetail" 
      (closeCommentDialog)="closeCommentDialogbox()">
    </app-comment-viewer>
}